import { useTranslations } from "next-intl";
import Star from "@/assets/icons/star.svg";
import { RATING_CATEGORY_FIELDS } from "@/features/rating/helpers/rating-category";
import type { RatingDetailsAverages } from "@/features/rating/types/product-rating.type";

export const RatingCategoryAverages = ({
  averages,
}: {
  averages: RatingDetailsAverages;
}) => {
  const t = useTranslations("rating.rateDialog.categories");

  return (
    <ul className="flex h-full flex-col justify-between gap-1.5 md:gap-y-2.5">
      {RATING_CATEGORY_FIELDS.map((field) => (
        <li className="flex items-center gap-x-2 md:gap-x-3" key={field}>
          <span className="whitespace-nowrap font-medium max-md:text-sm">
            {t(field)}
          </span>
          <span aria-hidden="true" className="h-px flex-1 bg-border" />
          <span className="flex shrink-0 items-center gap-x-1.5 whitespace-nowrap">
            <Star className="h-4 w-4 md:h-5 md:w-5 [&>path]:fill-brand-yellow" />
            <span className="w-7 text-left font-medium tabular-nums max-md:text-sm">
              {averages[field].toFixed(1)}
            </span>
          </span>
        </li>
      ))}
    </ul>
  );
};
